var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 21,
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 9,
  width: 21,
  height: 3,
  rx: 1.5,
  fill: "white"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  width: 21,
  height: 3,
  rx: 1.5,
  transform: "rotate(90 12 0)",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add-icon.a6ad09e526945f91d3084e7a25401c53.svg";